<ng-container *ngIf="!type || type === selectorTypeEnums.dropdown">
  <app-dropdown-single *ngIf="!multiple"
                       #selector
                       [(ngModel)]="value"
                       [disabled]="disabled"
                       [placeholder]="placeholder"
                       [styles]="styles"
                       [displayWith]="displayWithFn"
                       [options]="optionsFn"
                       [newItemLabel]="newItemLabel"
                       [tooltip]="tooltip"
                       (newItemClick)="newItemClick.emit()">
  </app-dropdown-single>

  <app-dropdown-multi *ngIf="multiple"
                      #selector
                      [(ngModel)]="value"
                      [disabled]="disabled"
                      [placeholder]="placeholder"
                      [styles]="styles"
                      [displayWith]="displayWithFn"
                      [options]="optionsFn"
                      [newItemLabel]="newItemLabel"
                      [tooltip]="tooltip"
                      (newItemClick)="newItemClick.emit()">
  </app-dropdown-multi>
</ng-container>


<ng-container *ngIf="type === selectorTypeEnums.chips">
  <mat-chip-listbox #selector
                    [(ngModel)]="value"
                    [multiple]="multiple"
                    [disabled]="disabled"
                    [ngStyle]="styles?.style"
                    [ngClass]="styles?.classes"
                    class="datex-chip-selector"
                    data-cy="chip-list"
                    [matTooltip]="tooltip">
    <mat-chip-option *ngFor="let item of options"
                     [value]="item.key"
                     [disabled]="item.disabled"
                     data-cy="chip">
      <span class="selector-option-text">{{item?.name}}</span>
    </mat-chip-option>
    <mat-chip-option *ngIf="newItemLabel && !disabled"
                     #newItem
                     [selectable]="false"
                     (click)="newItemClick.emit()"
                     class="new-item-chip"
                     data-cy="chip-newItem">
      {{newItemLabel}}
    </mat-chip-option>
    <span *ngIf="message"
          class="limited-options vertical-align-bottom">{{message}}</span>
  </mat-chip-listbox>
</ng-container>

<ng-container *ngIf="type === selectorTypeEnums.radioButtonsCheckboxes">
  <mat-radio-group *ngIf="!multiple"
                   #selector
                   [(ngModel)]="value"
                   [disabled]="disabled"
                   [ngStyle]="styles?.style"
                   [ngClass]="styles?.classes"
                   class="radio-group datex-radio-group"
                   data-cy="radio-group"
                   [matTooltip]="tooltip">
    <mat-radio-button *ngFor="let item of options"
                      [value]="item.key"
                      [disabled]="item.disabled"
                      tabIndex="0"
                      data-cy="radio-button"><span class="selector-option-text">{{item?.name}}</span></mat-radio-button>
    <span *ngIf="message"
          class="limited-options vertical-align-bottom">{{message}}</span>
  </mat-radio-group>

  <mat-selection-list *ngIf="multiple"
                      #selector
                      [(ngModel)]="value"
                      [disabled]="disabled"
                      [disableRipple]="true"
                      [ngStyle]="styles?.style"
                      [ngClass]="styles?.classes"
                      class="checkbox-group datex-checkbox-group"
                      data-cy="checkbox-group"
                      [matTooltip]="tooltip">
    <mat-list-option *ngFor="let item of options"
                     [value]="item.key"
                     [disabled]="item.disabled"
                     checkboxPosition="before"
                     data-cy="checkbox-option">
      <span class="selector-option-text">{{item?.name}}</span>
    </mat-list-option>
    <div *ngIf="message"
         class="limited-options">{{message}}</div>
  </mat-selection-list>
</ng-container>